import React, { Component } from "react";
import { Link } from "react-router-dom";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import AccountWidget from "../../components/shared/AccountWidget";

class PaymentFailed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      returnUrl: "/odeme",
      errorMessage: null,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    let returnUrl = "/odeme";
    let errorMessage =
      "Ödeme işleminiz tamamlanamadı. Lütfen kart bilgilerinizi kontrol edip tekrar deneyiniz.";

    const urlParams = new URLSearchParams(this.props.location.search);
    const failedReason = urlParams.get("reason");

    if (failedReason) {
      errorMessage = decodeURIComponent(failedReason);
    }

    const savedCheckoutUrl = localStorage.getItem("checkout_url");

    if (savedCheckoutUrl) {
      returnUrl = savedCheckoutUrl;
      localStorage.removeItem("checkout_url");
    }

    this.setState({ returnUrl, errorMessage });
  }

  handleRetry() {
    this.props.history.push(this.state.returnUrl);
  }

  render() {
    const { returnUrl, errorMessage } = this.state;

    return (
      <React.Fragment>
        <PageTitle title="Ödeme Başarısız" />
        <div className="row">
          <div className="container">
            <div className="row">
              <div className="col-md-9 mb-5">
                <div
                  style={{
                    padding: "40px 20px",
                    backgroundColor: "#fff5f5",
                    borderRadius: 8,
                    marginTop: 20,
                    border: "1px solid #ffdddd",
                  }}
                >
                  <div style={{ textAlign: "center", marginBottom: 30 }}>
                    <div
                      style={{
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        backgroundColor: "#dc3545",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 20,
                      }}
                    >
                      <i
                        className="fas fa-times"
                        style={{ fontSize: 40, color: "white" }}
                      ></i>
                    </div>
                    <h2
                      style={{
                        marginBottom: 10,
                        fontWeight: "bold",
                        color: "#dc3545",
                      }}
                    >
                      Ödeme İşlemi Başarısız
                    </h2>
                  </div>

                  <div
                    style={{
                      backgroundColor: "white",
                      padding: 30,
                      borderRadius: 8,
                      marginBottom: 20,
                    }}
                  >
                    <p
                      style={{
                        fontSize: 16,
                        marginBottom: 20,
                        lineHeight: 1.6,
                        color: "#333",
                      }}
                    >
                      {errorMessage}
                    </p>

                    <div
                      style={{
                        backgroundColor: "#fff3cd",
                        padding: 15,
                        borderRadius: 6,
                        borderLeft: "4px solid #ffc107",
                        marginTop: 20,
                      }}
                    >
                      <p
                        style={{
                          margin: 0,
                          fontSize: 14,
                          color: "#856404",
                        }}
                      >
                        <strong>Not:</strong> Sorun devam ederse lütfen bankanız
                        ile iletişime geçiniz veya farklı bir kart deneyiniz.
                      </p>
                    </div>
                  </div>

                  <div style={{ textAlign: "center", marginTop: 30 }}>
                    <button
                      onClick={this.handleRetry.bind(this)}
                      className="btn btn-primary"
                      style={{
                        marginRight: 10,
                        padding: "12px 40px",
                        fontSize: 16,
                      }}
                    >
                      <i className="fas fa-redo" style={{ marginRight: 8 }}></i>
                      Tekrar Dene
                    </button>
                    <Link
                      to="/"
                      className="btn btn-secondary"
                      style={{ padding: "12px 40px", fontSize: 16 }}
                    >
                      <i className="fas fa-home" style={{ marginRight: 8 }}></i>
                      Anasayfaya Dön
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <AccountWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default PaymentFailed;



// WEBPACK FOOTER //
// ./src/routers/Checkout/odeme-basarisiz.js